<template>
  <div id="brand-manager" class="page-content">
    <div class="title">
      Brand Manager
    </div>
    <div class="list">
      <EditBrandModal
        v-if="editBrand"
        :brand="editBrand"
        @closedBrandEdition="editBrand = null"
        class="category-edit-modal"
        @updatedBrand="updatedBrand"
        @createdBrand="createdBrand"
      />
      <div class="buttons navigation">
        <a class="btn-dark-button" @click="addNewBrand()">
          Create Brand
        </a>
        <a class="btn-dark-button" @click="getNewBrands()">
          Get new brands from parts
        </a>
      </div>
      <div class="navigation">
        <div class="bar">
          <button
            @click="filter = 'all'"
            class="tablinks"
            :class="{ active: filter == 'all' }"
          >
            All Brands
          </button>
          <button
            @click="filter = 'no_image'"
            class="tablinks"
            :class="{ active: filter == 'no_image' }"
          >
            No image
          </button>
          <button
            @click="filter = 'no_title_show'"
            class="tablinks"
            :class="{ active: filter == 'no_title_show' }"
          >
            No title Show
          </button>
          <button
            @click="filter = 'no_brand_type'"
            class="tablinks"
            :class="{ active: filter == 'no_brand_type' }"
          >
            No Brand Type
          </button>
          <button
            @click="filter = 'no_url'"
            class="tablinks"
            :class="{ active: filter == 'no_url' }"
          >
            No URL
          </button>
          <button
            @click="filter = 'disabled'"
            class="tablinks"
            :class="{ active: filter == 'disabled' }"
          >
            Disabled
          </button>
          <button
            @click="filter = 'enabled_only'"
            class="tablinks"
            :class="{ active: filter == 'enabled_only' }"
          >
            Enabled Only
          </button>
        </div>
      </div>
      <div class="input">
        <input
          class="regular full clear center-text"
          placeholder="Search by brand name"
          type="text"
          v-model="titleFilter"
        />
      </div>
      <div
        class="box"
        v-for="(brand, index) in brandsFilterd"
        :key="index + '-' + i"
      >
        <div
          class="status-circle left"
          :class="{
            enabled: brand.status == '1',
            disabled: brand.status == '0'
          }"
        ></div>
        <p class="title">{{ brand.nameShow }}</p>
        <div class="options">
          <a @click="editBrand = brand" class="icon">
            <img src="@/assets/icons/edit.svg" />
          </a>
          <a class="icon" @click="removeBrand(brand)">
            <img src="@/assets/icons/trash.svg" />
          </a>
        </div>
        <img :src="brand.image" class="brand-img" />
      </div>
    </div>
  </div>
</template>
<script>
import {
  getBrands,
  requestDeleteBrand,
  getNewBrands
} from "@/api/store/BrandsService.js";
import EditBrandModal from "@/components/shared/EditBrandModal.vue";

export default {
  components: {
    EditBrandModal
  },
  data() {
    return {
      brands: [],
      editBrand: null,
      brandsJson: null,
      showModalWithJSON: false,
      filter: "all",
      titleFilter: "",
      i: 1
    };
  },
  mounted() {
    this.loadBrands();
  },
  computed: {
    brandsFilterd() {
      this.i;
      let brandsFiltered;
      switch (this.filter) {
        case "all":
          brandsFiltered = this.brands;
          break;
        case "no_image":
          brandsFiltered = this.brands.filter(x => x.image == null);
          break;
        case "no_title_show":
          brandsFiltered = this.brands.filter(x => !x.nameShow);
          break;
        case "disabled":
          brandsFiltered = this.brands.filter(x => x.status == "0");
          break;
        case "enabled_only":
          brandsFiltered = this.brands.filter(x => x.status == "1");
          break;
        case "no_url":
          brandsFiltered = this.brands.filter(x => !x.url || x.url == "");
          break;
        case "no_brand_type":
          brandsFiltered = this.brands.filter(x => !x.type || x.type == "");
          break;
        default:
          brandsFiltered = this.brands;
          break;
      }
      if (this.titleFilter != "" && brandsFiltered) {
        brandsFiltered = brandsFiltered.filter(brand => {
          const nameShow = brand.nameShow ?? "";
          const name = brand.name ?? "";

          return (
            nameShow.toLowerCase().includes(this.titleFilter.toLowerCase()) ||
            name.toLowerCase().includes(this.titleFilter.toLowerCase())
          );
        });
      }

      return brandsFiltered;
    }
  },
  methods: {
    async getNewBrands() {
      let response = await getNewBrands().catch(() => {
        return false;
      });
      if (response && response.brandsAdded > 0) {
        this.$toast.open({
          message: `${response.message}`,
          type: "success",
          position: "top-right"
        });
        this.loadBrands();
      }
      if (response && response.brandsAdded == 0) {
        this.$toast.open({
          message: `${response.message}`,
          type: "warning",
          position: "top-right"
        });
      }
      if (!response) {
        this.$toast.open({
          message: `Error on request`,
          type: "error",
          position: "top-right"
        });
      }
    },
    async loadBrands() {
      this.brands = await getBrands().catch(() => {
        this.error = "Error Loading Brands.";
      });
    },
    createdBrand(brand) {
      this.editBrand = brand;
      this.brands.unshift(brand);
    },
    updatedBrand(brand) {
      let cat = this.brands.findIndex(x => {
        return x.id == brand.id;
      });
      this.brands[cat] = brand;
      this.editBrand = this.brands[cat];
      this.$nextTick(
        function() {
          this.i = this.i + 1;
        }.bind(this)
      );
    },
    async removeBrand(brand) {
      if (
        confirm(
          "Do you want to delete the brand " +
            brand.id +
            ' - "' +
            brand.title +
            '"'
        )
      ) {
        const res = await requestDeleteBrand(brand.id);
        console.log("res", res);
        if (res.status == "success") {
          this.$toast.open({
            message: `Brand deleted`,
            type: "success",
            position: "top-right"
          });
          this.brands = this.brands.filter(x => {
            return x.id != brand.id;
          });
        } else {
          this.$toast.open({
            message: `${res.message}`,
            type: "error",
            position: "top-right"
          });
        }
      }
    },
    addNewBrand() {
      this.editBrand = {
        avg: "",
        id: null,
        image: null,
        name: "",
        nameShow: "",
        status: 0,
        type: "",
        url: null
      };
    }
  }
};
</script>
<style lang="scss">
.category-edit-modal {
  &.modal {
    .modal-content {
      height: auto;
      width: 80%;
      padding: 0px;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "@/assets/style/css/App.scss";
#brand-manager {
  .input {
    width: 100%;
    margin: 10px 0;
  }
}
.list {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  .box {
    margin: 10px;
    height: 150px;
    width: 150px;
    overflow: hidden;
    padding: 5px;
    @extend .shadow-4dp;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 15px;
    text-align: center;
    position: relative;
    .options {
      display: none;
    }
    &:hover {
      .options {
        display: block;
        position: absolute;
        top: 10px;
        right: 10px;
        display: flex;
        flex-direction: row;
        .icon {
          border: 1px solid $M8;
          border-radius: 10px;
          padding: 5px;
          width: 30px;
          margin-left: 5px;
          &:hover {
            background-color: $M8;
          }
          img {
            width: 100%;
          }
        }
      }
    }
    .brand-img {
      max-width: 100px;
    }
    .title {
      margin-top: 0px;
      margin-bottom: 10px;
    }
  }
}
</style>
